// Keyboard containment for the open panel.

const FOCUSABLE =
  'a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'

export function focusables(root: HTMLElement): HTMLElement[] {
  return Array.from(root.querySelectorAll<HTMLElement>(FOCUSABLE)).filter(
    (n) => !n.hidden && n.offsetParent !== null,
  )
}

// Tab and Shift+Tab wrap inside `container`. Returns a function that
// removes the listener.
export function trapFocus(container: HTMLElement): () => void {
  const onKeydown = (e: KeyboardEvent) => {
    if (e.key !== 'Tab') return
    const nodes = focusables(container)
    if (nodes.length === 0) return
    const first = nodes[0]!
    const last = nodes[nodes.length - 1]!
    const active = (container.getRootNode() as ShadowRoot | Document).activeElement
    if (e.shiftKey && (active === first || !container.contains(active))) {
      e.preventDefault()
      last.focus()
    } else if (!e.shiftKey && active === last) {
      e.preventDefault()
      first.focus()
    }
  }
  container.addEventListener('keydown', onKeydown)
  return () => container.removeEventListener('keydown', onKeydown)
}
